import Model from '@/models/Model'
import CollectionModel from './CollectionModel'

export default class DrawerModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get uuid () {
    return this.get('id') || this.get('attributes.uuid')
  }

  get id () {
    return this.uuid
  }

  get name () {
    return this.get('attributes.name')
  }

  get subtitle () {
    return this.get('attributes.subtitle')
  }

  // get imageBig () {
  //   return this.get('rel.media.rel.field_image.attributes.url')
  // }

  get coverZoom () {
    return this.get('rel.media.rel.field_image.attributes.url')
  }

  get coverThumbnail () {
    return this.get('rel.media.rel.thumbnail.attributes.url')
  }

  get allImages () {
    return [{
      href: this.get('rel.media.rel.field_image.links.picture_cover_desktop.href'),
      thin_section_photo: false
    }]
  }

  get thumbnail () {
    return this.get('rel.media.rel.field_image.links.picture_block_mobile.href')
  }

  get collection () {
    return this.has('rel.collection') ? new CollectionModel(this.get('rel.collection'), this._included) : null
  }

  get prevDrawer () {
    return this.get('attributes.prev_drawer')
  }

  get nextDrawer () {
    return this.get('attributes.next_drawer')
  }
}
